export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/flags/LC-a377b29250bdb702a37f9dd212b6e3c4.png";